exports.PERMISSIONS_SCHEMA = {
  'advanced.users.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }, // Can create users that are already in his own group with predefined settings.
      { $value: true }
    ]
  },
  'advanced.users.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Can update it's own limited amount of data
      { $value: 'manager' },
      { $value: 'reseller' }, // Can update his own users. Limited data.
      { $value: true }
    ]
  },
  'advanced.users.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Can get his own profile by GET /users
      { $value: 'manager' },
      { $value: 'reseller' }, // Can get specific user profile by id
      { $value: true }
    ]
  },
  'advanced.users.find': {
    $default: false,
    $options: [
      { $value: false }, // Users do not have this options due to special treatment of get
      { $value: 'manager' },
      { $value: 'reseller' }, // Can list his own users
      { $value: true }
    ]
  },
  'advanced.users.remove': {
    $default: false,
    $options: [
      { $value: false }, // Only sudo can delete users. Change isActive instead
      { $value: true }
    ]
  },
  'advanced.users.setPermissions': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }, // Can set only limited permissions to their users. Can't change his own permissions.
      { $value: true }
    ]
  },
  'advanced.users.setTariffs': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }, // Can set only limited Tariffs to their users. Can't change his own Tariff.
      { $value: true }
    ]
  },
  'advanced.users.setRoutingGroups': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }, // Can set only limited RoutingGroups to their users. Can't change his own RoutingGroup.
      { $value: true }
    ]
  },
  'advanced.users.setSendernames': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }, // Can set only limited Sendernames to their users. Can't change his own Sendernames.
      { $value: true }
    ]
  },
  'advanced.users.setPatterns': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }, // Can set only limited Patterns to their users. Can't change his own Patterns.
      { $value: true }
    ]
  },
  'advanced.users.setMessageRuleGroups': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }, // Can set only limited Patterns to their users. Can't change his own Patterns.
      { $value: true }
    ]
  },
  'advanced.users.setOtpChannels': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.notifications.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Смотреть можно только свои уведомления
      { $value: true }
    ]
  },
  'advanced.notifications.setRead': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Отмечать прочитанным можно только свои уведомления
      { $value: true }
    ]
  },
  'advanced.notifications.trigger': { // Триггерить уведомления может только админ
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.sendings.generate': {
    $default: true,
    $options: [
      { $value: false }, // You can either be able to generate or not.
      { $value: true }
    ]
  },
  'advanced.sendings.create': {
    $default: false,
    $options: [
      { $value: false }, // Only sudo can create sendings. Use generate instead.
      { $value: true }
    ]
  },
  'advanced.sendings.update': {
    $default: false,
    $options: [
      { $value: false }, // Only sudo can update sendings
      { $value: true }
    ]
  },
  'advanced.sendings.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Can get his own sendings only
      { $value: 'reseller' }, // Can get his own + his users sendings
      { $value: 'manager' }, // Can get his own + his users sendings
      { $value: true }
    ]
  },
  'advanced.sendings.find': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Can list his own sendings only
      { $value: 'reseller' }, // Can list his own + his users sendings
      { $value: 'manager' }, // Can list his own + his users sendings
      { $value: true }
    ]
  },
  'advanced.sendings.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.sendingsIncoming.generate': {
    $default: true,
    $options: [
      { $value: false }, // You can either be able to generate or not.
      { $value: true }
    ]
  },
  'advanced.sendingsIncoming.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Can get his own sendingsIncoming only
      { $value: 'reseller' }, // Can get his own + his users sendingsIncoming
      { $value: true }
    ]
  },

  'advanced.tariffs.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Can create tariffs that this reseller only can use
      { $value: true }
    ]
  },
  'advanced.tariffs.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Can update tariffs he created
      { $value: true }
    ]
  },
  'advanced.tariffs.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Only own
      { $value: true }
    ]
  },
  'advanced.tariffs.find': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Only own
      { $value: true }
    ]
  },
  'advanced.tariffs.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Only own
      { $value: true }
    ]
  },

  'advanced.billings.finalize': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Resellers can finalize billings for their users
      { $value: true }
    ]
  },
  'advanced.billings.generate': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Resellers can generate billings for their users
      { $value: true }
    ]
  },
  'advanced.billings.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true } // Only sudo must have this options. Users should use generate action
    ]
  },
  'advanced.billings.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.billings.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.billings.find': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.billings.remove': {
    $default: false,
    $options: [
      { $value: false }, // Only sudo can delete billings. Use refund/invalid status.
      { $value: true }
    ]
  },

  'advanced.storage.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.storage.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.storage.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.storage.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.storage.upload': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.storage.download': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },

  'advanced.reports.generate': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users or their
      { $value: true }
    ]
  },
  'advanced.reports.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users or their
      { $value: true }
    ]
  },
  'advanced.reports.presetUsersBalance': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.contacts.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.contacts.find': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.contacts.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.contacts.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.contacts.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },

  'advanced.sendernames.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.sendernames.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.sendernames.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.sendernames.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },

  'advanced.patterns.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.patterns.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.patterns.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.patterns.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },

  'advanced.templates.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.templates.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.templates.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.templates.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },

  'advanced.requisites.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' },
      { $value: true }
    ]
  },
  'advanced.requisites.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' },
      { $value: true }
    ]
  },
  'advanced.requisites.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' },
      { $value: true }
    ]
  },
  'advanced.requisites.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' },
      { $value: true }
    ]
  },
  'advanced.requisites.controlDocuments': {
    $default: 'me',
    $options: [
      { $value: false }, // Не может пользоваться шаблонами документов
      { $value: 'me' }, // Может использовать шаблоны документов
      { $value: 'reseller' }, // Может назначать шаблоны документов своим юзерам
      { $value: true } // Может всё
    ]
  },

  'advanced.tasks.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.tasks.find': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.tasks.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.tasks.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.tasks.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },

  'advanced.payments.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.payments.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.payments.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.payments.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.paymentLogs.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.recurrentPayments.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.recurrentPayments.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.recurrentPayments.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.recurrentPayments.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },

  'advanced.settingsSite.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' },
      { $value: true }
    ]
  },
  'advanced.settingsSite.set': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' },
      { $value: true }
    ]
  },

  'advanced.settingsUser.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' },
      { $value: 'manager' },
      { $value: true }
    ]
  },
  'advanced.settingsUser.set': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' },
      { $value: 'manager' },
      { $value: true }
    ]
  },

  'advanced.contracts.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.contracts.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.contracts.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.contracts.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },

  'advanced.companies.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.companies.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.companies.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.companies.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },

  'advanced.documentTemplates.find': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.documentTemplates.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.documentTemplates.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.documentTemplates.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.documentTemplates.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },

  'advanced.dictionaries.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.dictionaries.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.dictionaries.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.dictionaries.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.dictionaries.seek': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.dictionaries.modify': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.operatorGroups.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.operatorGroups.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.operatorGroups.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.operatorGroups.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },

  'advanced.dadata.get': {
    $default: true,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.invoices.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' },
      { $value: 'manager' },
      { $value: true }
    ]
  },
  'advanced.invoices.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' },
      { $value: 'manager' },
      { $value: true }
    ]
  },
  'advanced.invoices.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' },
      { $value: 'manager' },
      { $value: true }
    ]
  },
  'advanced.invoices.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.otp-settings.channels.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.otp-settings.channels.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: true }
    ]
  },
  'advanced.otp-settings.channels.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.otp-settings.channels.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.otp-settings.templates.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.otp-settings.templates.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.otp-settings.templates.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.otp-settings.templates.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.otp-settings.widgets.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: true }
    ]
  },
  'advanced.otp-settings.widgets.get': {
    $default: false, // TODO: Временно не разрешаем, чтобы не показывать раздел на фронтеы
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: true }
    ]
  },
  'advanced.otp-settings.widgets.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: true }
    ]
  },
  'advanced.otp-settings.widgets.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: true }
    ]
  },
  // Общее право на использование otp-handler - создание кодов, их проверку и тд
  'advanced.otp-handler.use': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  // Для getOne / getMany из otp-handler request / channel
  'advanced.otp-handler.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  /*
   * Only sudo can change those:
   */
  'advanced.servers.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.servers.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.servers.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.servers.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.credentials.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.credentials.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.credentials.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.credentials.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.providers.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.providers.find': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.providers.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.providers.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.providers.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.providerGroups.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.providerGroups.find': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.providerGroups.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.providerGroups.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.providerGroups.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.routingRules.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.routingRules.find': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.routingRules.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.routingRules.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.routingRules.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.routingGroups.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.routingGroups.find': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.routingGroups.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.routingGroups.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.routingGroups.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.tokens.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.tokens.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.tokens.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.tokens.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },

  'advanced.apisender.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.apisender.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.apisender.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },
  'advanced.apisender.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: true }
    ]
  },

  'advanced.keywords.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.keywords.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.keywords.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.keywords.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.keywords.matchKeywords': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.messageRuleGroups.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.messageRuleGroups.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.messageRuleGroups.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.messageRuleGroups.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.messageRules.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.messageRules.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.messageRules.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.messageRules.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.yclients.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.yclients.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.yclients.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.yclients.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.eventsHistory.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.eventsHistory.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.eventsHistory.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.eventsHistory.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.userComments.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.userComments.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.sendingsModeration.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.sendingsModeration.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.sendingsModeration.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.sendingsModeration.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.sendingsModeration.getSendingsForTask': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.telemetry.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: true }
    ]
  },
  'advanced.telemetry.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: true }
    ]
  },
  'advanced.telemetry.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.telemetry.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.platform.health': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },

  'advanced.hlr.check': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: true }
    ]
  },

  'secret.showSecrets': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'secret.loginAs': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' },
      { $value: true }
    ]
  },
  'secret.viewChangelogs': {
    $default: false,
    $options: [
      { $value: false },
      { $value: true }
    ]
  }
  /*
   * The end of The Great List of Sudo-Only permissions
   */
}

const levels = [ 'child', 'me' ]
const { SETTINGS_USER_SCHEMA } = require('./user')
for (const level of levels) {
  for (const settingKey of Object.keys(SETTINGS_USER_SCHEMA)) {
    exports.PERMISSIONS_SCHEMA[`granular.${level}.settingsUser:${settingKey}`] = {
      $default: 'default',
      $options: [
        { $value: 'default' }, // Не применять особых прав для настройки
        { $value: false }, // Запретить смотреть или изменять настройку
        { $value: 'read' }, // Разрешить только читать настройку
        { $value: 'write' } // Разрешить читать и писать настройку
      ]
    }
  }
}

exports.RESELLER_PERMISSIONS_SCHEMA = {
  'advanced.users.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }
    ]
  },
  'advanced.users.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'manager' },
      { $value: 'reseller' }
    ]
  },
  'advanced.users.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'manager' },
      { $value: 'reseller' }
    ]
  },
  'advanced.users.find': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }
    ]
  },
  'advanced.users.setPermissions': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }
    ]
  },
  'advanced.users.setTariffs': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }
    ]
  },
  'advanced.users.setRoutingGroups': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }
    ]
  },
  'advanced.users.setSendernames': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }
    ]
  },
  'advanced.users.setPatterns': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'manager' },
      { $value: 'reseller' }
    ]
  },

  'advanced.sendings.generate': {
    $default: true,
    $options: [
      { $value: false },
      { $value: true }
    ]
  },
  'advanced.sendings.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }
    ]
  },
  'advanced.sendings.find': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }
    ]
  },

  'advanced.sendingsIncoming.generate': {
    $default: true,
    $options: [
      { $value: false }, // You can either be able to generate or not.
      { $value: true }
    ]
  },
  'advanced.sendingsIncoming.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Can get his own sendingsIncoming only
      { $value: 'reseller' } // Can get his own + his users sendingsIncoming
    ]
  },

  'advanced.tariffs.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }
    ]
  },
  'advanced.tariffs.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }
    ]
  },
  'advanced.tariffs.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }
    ]
  },
  'advanced.tariffs.find': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }
    ]
  },
  'advanced.tariffs.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }
    ]
  },

  'advanced.billings.generate': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }
    ]
  },
  'advanced.billings.finalize': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }
    ]
  },
  'advanced.billings.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }
    ]
  },
  'advanced.billings.find': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }
    ]
  },

  'advanced.storage.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.storage.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.storage.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.storage.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.storage.upload': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }
    ]
  },
  'advanced.storage.download': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }
    ]
  },

  'advanced.reports.generate': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }
    ]
  },
  'advanced.reports.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }
    ]
  },

  'advanced.contacts.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.contacts.find': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' } // Their users only
    ]
  },
  'advanced.contacts.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' } // Their users only
    ]
  },
  'advanced.contacts.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.contacts.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },

  'advanced.tasks.find': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.tasks.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.tasks.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.tasks.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },

  'advanced.requisites.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' },
      { $value: 'manager' }
    ]
  },
  'advanced.requisites.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' },
      { $value: 'manager' }
    ]
  },
  'advanced.requisites.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' },
      { $value: 'manager' }
    ]
  },
  'advanced.requisites.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' },
      { $value: 'manager' }
    ]
  },
  'advanced.requisites.controlDocuments': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }
    ]
  },

  'advanced.payments.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.payments.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.payments.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' } // Their users only
    ]
  },

  'advanced.recurrentPayments.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.recurrentPayments.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.recurrentPayments.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.recurrentPayments.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },

  'advanced.settingsSite.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }
    ]
  },
  'advanced.settingsSite.set': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'reseller' }
    ]
  },

  'advanced.settingsUser.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }
    ]
  },
  'advanced.settingsUser.set': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' },
      { $value: 'reseller' }
    ]
  },

  'advanced.tokens.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.tokens.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.tokens.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.tokens.remove': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },

  'advanced.apisender.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.apisender.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.apisender.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },
  'advanced.apisender.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' } // Their users only
    ]
  },

  'advanced.reports-manager.recurrent.create': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users or their
      { $value: true }
    ]
  },
  'advanced.reports-manager.recurrent.update': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users or their
      { $value: true }
    ]
  },
  'advanced.reports-manager.recurrent.get': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users or their
      { $value: true }
    ]
  },
  'advanced.reports-manager.recurrent.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users or their
      { $value: true }
    ]
  },

  'advanced.reports-manager.queue.create': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users or their
      { $value: true }
    ]
  },
  'advanced.reports-manager.queue.update': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users or their
      { $value: true }
    ]
  },
  'advanced.reports-manager.queue.get': {
    $default: 'me',
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users or their
      { $value: true }
    ]
  },
  'advanced.reports-manager.queue.remove': {
    $default: false,
    $options: [
      { $value: false },
      { $value: 'me' }, // Their only
      { $value: 'reseller' }, // Their users only
      { $value: 'manager' }, // Their users or their
      { $value: true }
    ]
  }
}

exports.SUDO_PERMISSIONS = {
  advanced: {
    users: {
      find: true,
      get: true,
      create: true,
      update: true,
      remove: true,
      setPermissions: true,
      setTariffs: true,
      setRoutingGroups: true,
      setSendernames: true,
      setPatterns: true,
      setMessageRuleGroups: true,
      setOtpChannels: true
    },
    notifications: {
      get: true,
      setRead: true,
      trigger: true
    },
    sendings: {
      find: true,
      get: true,
      generate: true,
      create: true,
      update: true,
      remove: true
    },
    sendingsIncoming: {
      generate: true,
      get: true
    },
    tariffs: {
      find: true,
      get: true,
      create: true,
      update: true,
      remove: true
    },
    billings: {
      finalize: true,
      generate: true,
      find: true,
      get: true,
      create: true,
      update: true,
      remove: true
    },
    storage: {
      edit: true,
      create: true,
      update: true,
      get: true,
      remove: true,
      upload: true,
      download: true
    },
    reports: {
      generate: true,
      get: true,
      presetUsersBalance: true
    },
    contacts: {
      create: true,
      find: true,
      get: true,
      update: true,
      remove: true
    },
    sendernames: {
      create: true,
      get: true,
      update: true,
      remove: true
    },
    patterns: {
      create: true,
      get: true,
      update: true,
      remove: true
    },
    templates: {
      create: true,
      get: true,
      update: true,
      remove: true
    },
    requisites: {
      create: true,
      get: true,
      update: true,
      remove: true,
      controlDocuments: true
    },
    tasks: {
      create: true,
      find: true,
      update: true,
      get: true,
      remove: true
    },
    settingsSite: {
      get: true,
      set: true
    },
    settingsUser: {
      get: true,
      set: true
    },
    // FIXME: [SO-512] Обратная совместимость, удалить после релиза прав payments.*
    payment: {
      request: true
    },
    payments: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    paymentLogs: {
      get: true
    },
    recurrentPayments: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    servers: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    credentials: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    providers: {
      find: true,
      get: true,
      create: true,
      update: true,
      remove: true
    },
    providerGroups: {
      find: true,
      get: true,
      create: true,
      update: true,
      remove: true
    },
    routingRules: {
      find: true,
      get: true,
      create: true,
      update: true,
      remove: true
    },
    routingGroups: {
      find: true,
      get: true,
      create: true,
      update: true,
      remove: true
    },
    dictionaries: {
      get: true,
      create: true,
      update: true,
      remove: true,
      seek: true,
      modify: true
    },
    platform: {
      health: true
    },
    contracts: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    companies: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    documentTemplates: {
      find: true,
      get: true,
      create: true,
      update: true,
      remove: true
    },
    operatorGroups: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    dadata: {
      get: true
    },
    invoices: {
      create: true,
      get: true,
      update: true,
      remove: true
    },
    'otp-settings': {
      channels: {
        create: true,
        get: true,
        update: true,
        remove: true
      },
      templates: {
        create: true,
        get: true,
        update: true,
        remove: true
      },
      widgets: {
        create: true,
        get: true,
        update: true,
        remove: true
      }
    },
    'otp-handler': {
      use: true,
      get: true
    },
    tokens: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    apisender: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    keywords: {
      get: true,
      create: true,
      update: true,
      remove: true,
      matchKeywords: true
    },
    messageRuleGroups: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    messageRules: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    yclients: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    eventsHistory: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    userComments: {
      get: true,
      create: true
    },
    sendingsModeration: {
      get: true,
      create: true,
      update: true,
      remove: true,
      getSendingsForTask: true
    },
    telemetry: {
      get: true,
      create: true,
      update: true,
      remove: true
    },
    hlr: {
      check: true
    }
  },
  secret: {
    loginAs: true,
    showSecrets: true,
    viewChangelogs: true
  }
}
